import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable, DataTableExpandedRows } from "primereact/datatable";
import { Toolbar } from "primereact/toolbar";
import React, { useEffect, useRef, useState } from "react";
import { format } from "date-fns";
import { ILogin, IPermissionProps } from "../../../models/Login";
import { Fetch } from "../../../shared/Fetch";
import { Dialog } from "primereact/dialog";
import { Card } from "primereact/card";
import { ApproveSchedulerForm } from "./ApproveSchedulerForm";
import { TrainingStatusForm } from "./TrainingStatusForm";
import { MultiTrainingSchedulerForm } from "../trainingFormSubmission/MultiTrainingSchedulerForm";

interface IProps {
    setModal: (modal: { open: boolean, singleData: any }) => void,
    reload: boolean,
    permission: IPermissionProps,
    toast: any,
    reloadTable: () => void,
}

export interface ITrainingSchedules {
    schedule_ID?: number,
    form_ID?: number,
    login_ID?: number,
    trainer_Name?: string,
    company_Name?: string,
    trainer_BranchName?: string,
    topic_Name?: string,
    category_Name?: string,
    no_Of_Trainees?: number,
    branchName?: string,
    training_Date?: Date,
    // training_Date_To?: Date,
    training_Time_From?: Date,
    training_Time_To?: Date,
    schedule_Status?: boolean,
    rejection_Comment?: string,
    added_By?: string,
    added_On?: Date,
    updated_By?: string,
    updated_On?: Date,
    training_Status?: boolean,
    training_Status_ID?: number
}



export const Table = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: ITrainingSchedules[], loading: boolean });
    const [tableData1, setTableData1] = useState({ tableData: [], loading: false } as { tableData: ITrainingSchedules[], loading: boolean });
    const [openRejection, setOpenRejection] = useState({ open: false, singleData: {} } as { open: boolean, singleData: ITrainingSchedules });
    const [openAprvForm, setOpenAprvForm] = useState({ open: false, singleData: {} } as { open: boolean, singleData: ITrainingSchedules });
    const [openTrainingStatusForm, setOpenTrainingStatusForm] = useState({ open: false, singleData: {} } as { open: boolean, singleData: ITrainingSchedules });
    const [expandedRows, setExpandedRows] = useState<DataTableExpandedRows | any | undefined>(undefined);
    const [openMultiAprvForm, setOpenMultiAprvForm] = useState({ open: false, singleData: {} } as { open: boolean, singleData: ITrainingSchedules });
    const dt = useRef<any>(null);
    const openNew = () => {
        props.setModal({ open: true, singleData: { category_ID: 0, topic_ID: 0 } });
    };

    const _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    const leftToolbarTemplate = () => {
        return (

            <React.Fragment>
                <div className="my-2">
                    <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
                </div>
            </React.Fragment>
        );
    };

    const leftToolbarTemplate2 = (data: any) => {
        return (

            <React.Fragment>
                <div className="my-2">
                    <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={() => setOpenMultiAprvForm({ open: true, singleData: data })} />
                </div>
            </React.Fragment>
        );
    };

    const header = () => <p>Training Schedules</p>;

    const openEdit = (data: ITrainingSchedules) => props.setModal({
        open: true, singleData: {
            schedule_ID: data.schedule_ID,
            form_ID: data.form_ID,
            no_Of_Trainees: data.no_Of_Trainees,
            branchName: data.branchName,
            training_Date: data.training_Date,
            // training_Date_To: data.training_Date_To,
            training_Time_From: data.training_Time_From,
            training_Time_To: data.training_Time_To,
        }
    });

    const action = (rowData: any) => {
        return (
            <div className="flex gap-3">
                {(rowData.schedule_Status === null || rowData.schedule_Status === false || (_roles.includes(1) || _roles.includes(26))) && (props.permission.is_Update || (_roles.includes(1) || _roles.includes(26))) && <Button className="pi pi-pencil text-primary bg-white border-none" onClick={() => openEdit(rowData)}></Button>}
            </div>
        );
    };

    const addDate = (rowData: ITrainingSchedules) => {
        let date;
        if (rowData.added_On) date = format(new Date(rowData.added_On), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const updateDate = (rowData: ITrainingSchedules) => {
        let date;
        if (rowData.updated_On) date = format(new Date(rowData.updated_On), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const trainingFromDate = (rowData: ITrainingSchedules) => {
        let date;
        if (rowData.training_Date) date = format(new Date(rowData.training_Date), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    // const trainingToDate = (rowData: ITrainingSchedules) => {
    //     let date;
    //     if (rowData.training_Date_To) date = format(new Date(rowData.training_Date_To), 'dd/MM/yyyy').toUpperCase();
    //     else date = "";
    //     return (<>{date}</>);
    // };
    const trainingFromTime = (rowData: ITrainingSchedules) => {
        let date;
        if (rowData.training_Time_From) date = format(new Date(rowData.training_Time_From), 'hh:mm  a').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const trainingToTime = (rowData: ITrainingSchedules) => {
        let date;
        if (rowData.training_Time_To) date = format(new Date(rowData.training_Time_To), 'hh:mm  a').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const durationTime = (rowData: ITrainingSchedules) => {
        let diffMinutes: any = "";
        if (rowData.training_Time_From && rowData.training_Time_To) {
            const diffMs = new Date(rowData.training_Time_To || "").getTime() - new Date(rowData.training_Time_From || "").getTime();
            diffMinutes = diffMs / (1000 * 60);
        }
        return (<>{diffMinutes !== "" ? (diffMinutes + " min") : diffMinutes}</>);
    };

    const approveStatus = (rowData: ITrainingSchedules) => {
        return (<p className={rowData.schedule_Status === false ? "cursor-pointer underline" : (rowData.schedule_Status === null ? "cursor-pointer underline" : "")} style={{ color: rowData.schedule_Status === false ? "red" : (rowData.schedule_Status === true ? "green" : "black") }} onClick={() => {
            if (rowData.schedule_Status === null && ((rowData.login_ID === loginObj.id) || (_roles.includes(1) || _roles.includes(26)))) {
                setOpenAprvForm({ open: true, singleData: rowData });
            }
            if (rowData.schedule_Status === true && (_roles.includes(1) || _roles.includes(26))) {
                setOpenAprvForm({ open: true, singleData: rowData });
            }
            if (rowData.schedule_Status === false) {
                setOpenRejection({ open: true, singleData: rowData });
            }
        }}>{rowData.schedule_Status === true ? "Accepted" : (rowData.schedule_Status === false ? "Rejected" : "Pending")}</p>);
    };
    const trainingStatus = (rowData: ITrainingSchedules) => {
        return <p className={(rowData.training_Status === true || rowData.training_Status === false) ? "cursor-pointer underline" : ""} style={{ color: rowData.training_Status === null ? "black" : (rowData.training_Status === true ? "green" : "red") }} onClick={() => {
            if (rowData.login_ID !== loginObj.id && !(_roles.includes(1) || _roles.includes(26))) {
            } else if (rowData.schedule_Status !== true) {
                props.toast.current.show({ severity: 'error', detail: "Schedule Is Not Accepted", life: 3000 });
            } else if (((rowData.login_ID === loginObj.id) || (_roles.includes(1) || _roles.includes(26))) && ((new Date(rowData.training_Time_From || "").getDate() < new Date().getDate() && (new Date(rowData.training_Time_From || "").getMonth() + 1) <= (new Date().getMonth() + 1) && new Date(rowData.training_Time_From || "").getFullYear() <= new Date().getFullYear()) || (new Date(rowData.training_Time_From || "").getHours() === new Date().getHours() && new Date(rowData.training_Time_From || "").getMinutes() < new Date().getMinutes()) || (new Date(rowData.training_Time_From || "").getHours() < new Date().getHours()))) {
                setOpenTrainingStatusForm({ open: true, singleData: rowData });
            } else props.toast.current.show({ severity: 'error', detail: "Training Not Started Yet, Can update after Training Started", life: 3000 });
        }}>{rowData.training_Status === null ? "Pending" : (rowData.training_Status === true ? "Completed" : "Cancelled")}</p>
    }

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const res = await Fetch("CarnivalTraining/getTrainingSchedules", "GET", null, null, props.toast);
        if (res) {
            const data: any[] = await res.json();
            const unique: ITrainingSchedules[] = Object.values(
                data.reduce((acc, item) => {
                    if (!acc[item.form_ID]) acc[item.form_ID] = item;
                    return acc;
                }, {})
            );
            setTableData1({ tableData: data, loading: false });
            setTableData({ tableData: unique, loading: false });
        } else setTableData({ tableData: tableData.tableData, loading: false });
    }

    const rowExpansionTemplate = (rowData: ITrainingSchedules) => {
        const data: ITrainingSchedules[] = tableData1.tableData.filter((f: ITrainingSchedules) => f.form_ID === rowData.form_ID);
        return (
            <div className="p-3">
                {(props.permission.is_Create || (_roles.includes(1) || _roles.includes(26))) && <Toolbar className="mb-1 py-0" left={() => leftToolbarTemplate2(rowData)}></Toolbar>}
                <DataTable value={data} stripedRows showGridlines responsiveLayout="scroll">
                    <Column field="branchName" header="Training Branch" />
                    <Column field="training_Date" header="Training Date" body={(rowData: ITrainingSchedules) => trainingFromDate(rowData)} />
                    {/* <Column field="training_Date_To" header="To" body={(rowData: ITrainingSchedules) => trainingToDate(rowData)} /> */}
                    <Column field="training_Time_From" header="Time From" body={(rowData: ITrainingSchedules) => trainingFromTime(rowData)} />
                    <Column field="training_Time_To" header="Time To" body={(rowData: ITrainingSchedules) => trainingToTime(rowData)} />
                    <Column field="no_Of_Trainees" header="No Of Trainees" />
                    <Column field="" header="Time Duration" body={(rowData: ITrainingSchedules) => durationTime(rowData)} />
                    <Column field="schedule_Status" header="Status" body={(rowData: ITrainingSchedules) => approveStatus(rowData)} />
                    <Column field="added_By" header="Added By" />
                    <Column field="added_On" header="Added On" body={(rowData: ITrainingSchedules) => addDate(rowData)} />
                    <Column field="updated_By" header="Updated By" />
                    <Column field="updated_On" header="Updated On" body={(rowData: ITrainingSchedules) => updateDate(rowData)} />
                    <Column field="training_Status" header="Training Status" body={(rowData: ITrainingSchedules) => trainingStatus(rowData)} />
                    {(props.permission.is_Update || (_roles.includes(1) || _roles.includes(26))) && <Column header="Action" body={action} />}
                </DataTable>
                <MultiTrainingSchedulerForm open={openMultiAprvForm.open} singleData={openMultiAprvForm.singleData} form_ID={openMultiAprvForm.singleData?.form_ID || 0} hideDialog={() => setOpenMultiAprvForm({ open: false, singleData: {} })} toast={props.toast} />
            </div>
        );
    };

    useEffect(() => {
        loadTableData();
    }, [props.reload]);

    return (
        <>
            {/* <Toolbar className="mb-1 py-0" left={leftToolbarTemplate}></Toolbar> */}
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                ref={dt} size="small" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                lazy dataKey="schedule_ID"
                emptyMessage="No Record found."
                value={tableData.tableData} loading={tableData.loading}
                header={header}
                expandedRows={expandedRows} onRowToggle={(e) => setExpandedRows(e.data)}
                rowExpansionTemplate={rowExpansionTemplate}
            >
                <Column expander={true} style={{ width: '5rem' }} />
                <Column header="SN." body={(data, options) => options.rowIndex + 1} />
                <Column field="trainer_Name" header="Trainer" />
                <Column field="company_Name" header="Company" />
                <Column field="trainer_BranchName" header="Branch" />
                <Column field="topic_Name" header="Topic" />
                <Column field="category_Name" header="Category" />
            </DataTable>
            <ApproveSchedulerForm open={openAprvForm.open} singleData={openAprvForm.singleData} toast={props.toast} hideDialog={() => {
                setOpenAprvForm({ open: false, singleData: {} });
                setOpenRejection({ open: false, singleData: {} });
                setOpenRejection({ open: false, singleData: {} });
            }} reloadTable={() => props.reloadTable()} />
            <Dialog visible={openRejection.open} style={{ width: '50vw' }} header="Rejection Reason" modal className="p-fluid" onHide={() => setOpenRejection({ open: false, singleData: {} })}>
                <Card className="flex flex-column">
                    <p>{openRejection.singleData.rejection_Comment}</p>
                    <hr></hr>
                    <div className="w-full flex flex-row-reverse">{(openRejection.singleData.schedule_Status === false) && (_roles.includes(1) || _roles.includes(26)) && <Button label="Change Status" icon="pi pi-tick" className="p-button-primary mr-2 w-3" onClick={() => setOpenAprvForm({ open: true, singleData: openRejection.singleData })} />}</div>
                </Card>
            </Dialog>
            <TrainingStatusForm open={openTrainingStatusForm.open} singleData={openTrainingStatusForm.singleData} hideDialog={() => setOpenTrainingStatusForm({ open: false, singleData: {} })} toast={props.toast} reloadTable={() => props.reloadTable()} />
        </>
    );
}